"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterPolicyEndorsement = exports.eMasterPolicyEndorsementType = void 0;
const MasterPolicyInsuranceLicense_class_1 = require("./MasterPolicyInsuranceLicense.class");
const address_1 = __importDefault(require("../address"));
var eMasterPolicyEndorsementType;
(function (eMasterPolicyEndorsementType) {
    eMasterPolicyEndorsementType["LICENSE_CHANGE"] = "LICENSE_CHANGE";
    eMasterPolicyEndorsementType["PARTNER_NAME_CHANGE"] = "PARTNER_NAME_CHANGE";
    eMasterPolicyEndorsementType["PARTNER_ADDRESS_CHANGE"] = "PARTNER_ADDRESS_CHANGE";
    eMasterPolicyEndorsementType["PARTICIPATING_INSURERS_CHANGE"] = "PARTICIPATING_INSURERS_CHANGE";
})(eMasterPolicyEndorsementType = exports.eMasterPolicyEndorsementType || (exports.eMasterPolicyEndorsementType = {}));
class MasterPolicyEndorsement {
    constructor(effectiveDate, type, insuranceLicense, change) {
        this.effectiveDate = effectiveDate;
        this.type = type;
        this.insuranceLicense = insuranceLicense;
        this.change = change;
    }
    static getChangeInstance(type, obj) {
        if (!obj) {
            return undefined;
        }
        if (type === eMasterPolicyEndorsementType.PARTNER_ADDRESS_CHANGE) {
            return {
                old: address_1.default.fromObj(obj.old),
                new: address_1.default.fromObj(obj.new)
            };
        }
        if (type === eMasterPolicyEndorsementType.LICENSE_CHANGE) {
            return {
                old: MasterPolicyInsuranceLicense_class_1.MasterPolicyInsuranceLicense.fromObj(obj.old),
                new: MasterPolicyInsuranceLicense_class_1.MasterPolicyInsuranceLicense.fromObj(obj.new)
            };
        }
        if (type === eMasterPolicyEndorsementType.PARTICIPATING_INSURERS_CHANGE) {
            return {
                old: obj.old,
                new: obj.new
            };
        }
        return {
            old: obj.old,
            new: obj.new
        };
    }
    static fromObj(obj) {
        return new MasterPolicyEndorsement(obj.effectiveDate, obj.type, MasterPolicyEndorsement.getChangeInstance(obj.type, obj.insuranceLicense), MasterPolicyEndorsement.getChangeInstance(obj.type, obj.change || obj.insuranceLicense));
    }
}
exports.MasterPolicyEndorsement = MasterPolicyEndorsement;
//# sourceMappingURL=MasterPolicyEndorsement.class.js.map